import React, { useEffect, useState } from 'react';
import {Button, Layout, Menu} from 'antd';
import { useLocation, useNavigate } from 'react-router-dom';
import { ServiceInfo } from "../entities/ServiceInfo";
import {DEPLOY_ENV} from "../utils/config";
import ServiceDetailPage from "./ServiceDetailPage";
import {ServiceInfoService} from "../http/ServiceInfoService";
import MwsEnvironmentSelector from "../components/MwsEnvironmentSelector";
import './ServiceListPage.css';
import {ArrowLeftOutlined} from "@ant-design/icons";

const { Header, Sider, Content } = Layout;

const ServiceListPage = (): React.JSX.Element => {
    document.title = 'Nginx服务器节点';
    const [appList, setAppList] = useState<ServiceInfo[]>([]);
    const [selectedApp, setSelectedApp] = useState<ServiceInfo | null>(null);

    const navigate = useNavigate();
    const location = useLocation();
    const params = new URLSearchParams(location.search);
    const appKey = params.get('appKey');

    useEffect(() => {
        ServiceInfoService.listServiceInfo().then((data) => {
            if (data) {
                setAppList(data);
            }
        });
    }, []);

    useEffect(() => {
        if (appList.length === 0) {
            return;
        }
        const foundApp = appList.find(app => app.appKey === appKey) || appList[0];
        setSelectedApp(foundApp);

        ServiceInfoService.getServiceInfo({ appKey: foundApp.appKey, env: DEPLOY_ENV}).then((response) => {
            if (response.isFailed() || !response.data) {
                return;
            }
            setSelectedApp(response.data);
        });
    }, [appList, appKey]);

    const handleMenuSelect = async ({ key }: { key: string }) => {
        const foundApp = appList.find(app => app.appKey === key) || null;
        setSelectedApp(foundApp);
        const params = new URLSearchParams(location.search);
        params.set('appKey', key);
        navigate({ search: params.toString() });
    };

    return (
        <Layout className="service-list-page">
            <Header className="service-list-page-header">
                <div className="header-title">
                    <Button className="back-button" type="link" style={{ color: 'black'}}
                            icon={<ArrowLeftOutlined />} onClick={() => navigate('/')} />
                    Nginx服务器节点
                    <MwsEnvironmentSelector prefix="nginx" enableDevHost={true} />
                </div>
            </Header>
            <Layout>
                <Sider className="service-list-page-sider" width="15%">
                    <Menu
                        className="service-list-menu"
                        mode="vertical"
                        selectedKeys={[selectedApp?.appKey || ""]}
                        onSelect={handleMenuSelect}
                    >
                        {appList.map((app) => (
                            <Menu.Item key={app.appKey}>
                                <div className="service-item"><div className="service-name">{app.name}</div>
                                    <div className="service-appKey">{app.appKey}</div>
                                </div>
                            </Menu.Item>
                        ))}
                    </Menu>
                </Sider>

                <Layout className="service-list-page-content-layout">
                    <Content className="service-list-page-content">
                        {selectedApp ? (
                            <ServiceDetailPage appKey={selectedApp.appKey} />
                        ) : (
                            <div className="no-data">没有服务</div>
                        )}
                    </Content>
                </Layout>
            </Layout>
        </Layout>
    );
};

export default ServiceListPage;
